module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 130);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  1:
  /***/
  function _(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  130:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _Checkbox = __webpack_require__(131);

    var _Checkbox2 = _interopRequireDefault(_Checkbox);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    exports.default = _Checkbox2.default;
    /***/
  },

  /***/
  131:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = Checkbox;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _classnames = __webpack_require__(2);

    var _classnames2 = _interopRequireDefault(_classnames);

    var _Tick = __webpack_require__(132);

    var _Tick2 = _interopRequireDefault(_Tick);

    var _border = __webpack_require__(133);

    var _border2 = _interopRequireDefault(_border);

    var _color = __webpack_require__(134);

    var _color2 = _interopRequireDefault(_color);

    var _general = __webpack_require__(135);

    var _general2 = _interopRequireDefault(_general);

    var _shape = __webpack_require__(136);

    var _shape2 = _interopRequireDefault(_shape);

    var _type = __webpack_require__(137);

    var _type2 = _interopRequireDefault(_type);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    var sizes = {
      small: 24,
      medium: 30
    };

    function Checkbox(_ref) {
      var _cx, _cx2;

      var align = _ref.align,
          border = _ref.border,
          checked = _ref.checked,
          color = _ref.color,
          disabled = _ref.disabled,
          fullWidth = _ref.fullWidth,
          label = _ref.label,
          name = _ref.name,
          onChange = _ref.onChange,
          shape = _ref.shape,
          size = _ref.size,
          type = _ref.type,
          value = _ref.value,
          width = _ref.width;
      var computedSize = width !== undefined ? width : sizes[size];
      var controlProps = {
        className: (0, _classnames2.default)(_general2.default.control, {
          'display-inlineBlock': !fullWidth && label
        }),
        style: {
          width: label ? null : computedSize,
          height: label ? null : computedSize
        }
      };
      var inputProps = {
        checked: checked,
        className: _general2.default.input,
        disabled: disabled,
        name: name,
        onChange: onChange,
        type: 'checkbox',
        value: value
      };
      var indicatorProps = {
        className: (0, _classnames2.default)(_general2.default.indicator, _shape2.default[shape], [_border2.default[border]], (_cx = {}, _defineProperty(_cx, _type2.default[type], !checked), _defineProperty(_cx, _color2.default[color], checked), _defineProperty(_cx, 'pinTL', align === 'left'), _defineProperty(_cx, 'pinTR', align === 'right'), _defineProperty(_cx, 'boxShadow-none', checked), _cx)),
        style: {
          width: computedSize,
          height: computedSize
        }
      };
      var tickProps = {
        className: (0, _classnames2.default)(_general2.default.tick),
        style: {
          opacity: 1,
          transform: checked ? 'scale(1)' : 'scale(0)'
        }
      };
      var labelProps = {
        className: (0, _classnames2.default)(_general2.default.label, (_cx2 = {}, _defineProperty(_cx2, _general2.default.labelDefault, !checked), _defineProperty(_cx2, _general2.default.labelActive, checked), _defineProperty(_cx2, 'marginLeft-xs', align === 'left'), _defineProperty(_cx2, 'marginRight-xs', align === 'right'), _cx2)),
        style: {
          paddingLeft: align === 'left' ? computedSize : 0,
          paddingRight: align === 'right' ? computedSize : 0,
          height: computedSize,
          lineHeight: computedSize + 'px'
        }
      };
      return _react2.default.createElement('label', controlProps, _react2.default.createElement('input', inputProps), _react2.default.createElement('div', indicatorProps, _react2.default.createElement('span', tickProps, _react2.default.createElement(_Tick2.default, null))), label && _react2.default.createElement('div', labelProps, label));
    }

    Checkbox.propTypes = {
      align: _propTypes2.default.oneOf(['left', 'right']).isRequired,
      border: _propTypes2.default.oneOf(Object.keys(_border2.default)),
      checked: _propTypes2.default.bool.isRequired,
      color: _propTypes2.default.oneOf(Object.keys(_color2.default)).isRequired,
      disabled: _propTypes2.default.bool.isRequired,
      fullWidth: _propTypes2.default.bool.isRequired,
      label: _propTypes2.default.string,
      name: _propTypes2.default.string,
      onChange: _propTypes2.default.func,
      shape: _propTypes2.default.oneOf(Object.keys(_shape2.default)),
      size: _propTypes2.default.oneOf(Object.keys(sizes)).isRequired,
      type: _propTypes2.default.oneOf(Object.keys(_type2.default)),
      value: _propTypes2.default.string,
      width: _propTypes2.default.number
    };
    Checkbox.defaultProps = {
      align: 'left',
      border: 'defaultThick',
      checked: false,
      color: 'green',
      disabled: false,
      fullWidth: false,
      shape: 'circle',
      size: 'medium',
      type: 'default',
      width: undefined
    };
    /***/
  },

  /***/
  132:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = Tick;

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function Tick() {
      return _react2.default.createElement("svg", {
        className: "display-block",
        viewBox: "0 0 30 30"
      }, _react2.default.createElement("path", {
        d: "M13.08,16.53l-2.08-2a1.7,1.7,0,0,0-2.48,0,1.88,1.88,0,0,0,0,2.59L12,20.46a1.71,1.71,0,0,0,1.27.54,1.75,1.75,0,0,0,1.3-.55l6.91-8.23a2,2,0,0,0,0-2.66,1.73,1.73,0,0,0-2.54,0l-5.85,7h0Z"
      }));
    }
    /***/

  },

  /***/
  133:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "defaultThick": "border__defaultThick___11foi boxShadow-smoke--2 boxShadow-smoke--xd--2--hover",
      "defaultThin": "border__defaultThin___L2Wky boxShadow-smoke boxShadow-smoke--xd--hover",
      "transparentThin": "border__transparentThin___r8Cpa boxShadow-white--transparent",
      "transparentThick": "border__transparentThick___3rvZ2 boxShadow-white--transparent--2"
    };
    /***/
  },

  /***/
  134:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "blue": "color__blue___johiA bg-blue",
      "green": "color__green___IpwMC bg-green"
    };
    /***/
  },

  /***/
  135:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "control": "general__control___3Clwy cursor-pointer display-block position-relative userSelect-none",
      "input": "general__input___29thL opacity-0 position-absolute zi-negative",
      "indicator": "general__indicator___3mb6p display-block position-absolute transitionDuration-xl transitionTimingFunction-cb--scaleIn userSelect-none",
      "tick": "general__tick___Ma_bg display-block fill-white opacity-0 transitionDuration-xl transitionTimingFunction-cb--scaleIn",
      "label": "general__label___2EDKq link",
      "labelDefault": "general__labelDefault___2l7af c-silver c-slate--hover",
      "labelActive": "general__labelActive___368CQ c-black--hover c-slate"
    };
    /***/
  },

  /***/
  136:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "circle": "shape__circle___6d8Q5 borderRadius-circle",
      "square": "shape__square___3JPlF borderRadius-m"
    };
    /***/
  },

  /***/
  137:
  /***/
  function _(module, exports) {
    // removed by extract-text-webpack-plugin
    module.exports = {
      "default": "type__default___23Qi9 bg-snow--hover bg-white",
      "transparent": "type__transparent___CJ48u bg-none"
    };
    /***/
  },

  /***/
  2:
  /***/
  function _(module, exports) {
    module.exports = require("classnames");
    /***/
  }
  /******/

});